/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Drawer_Inherit_OptionInputs */



/**
* | output |
* | --- |
* | "Organization default" |
*
* @param {Rights_Drawer_Inherit_OptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_drawer_inherit_option = /** @type {((inputs?: Rights_Drawer_Inherit_OptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Drawer_Inherit_OptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Org-Standard")
	return /** @type {LocalizedString} */ ("Organization default")
});